<template>
	<a
		:class="['item-box', {'one-img': imgs.length === 1}, {'more-img': imgs.length > 1}]"
		:href="data.url"
		target="_blank"
	>
		<div class="main-area">
			<div class="text-area">
				<p class="news-title">{{data.title}}</p>
				<newsInfo :data="data" v-if="imgs.length === 1" />
			</div>
			<div class="img-area" v-if="!!imgs.length">
				<img class="news-img" v-for="(img, index) in imgs" v-lazy="img" :key="index" />
				<div v-if="imgs.length === 2" class="news-img"></div>
			</div>
		</div>
		<newsInfo :data="data" v-if="imgs.length !== 1" />
	</a>
</template>
<script>
	import newsInfo from "./newsInfo";
	export default {
		name: "NewsItem",
		props: {
			data: {
				required: true,
				type: Object,
			},
		},
		components: {
			newsInfo,
		},
		computed: {
			imgs() {
				let res = [];
				this.data.imgs.forEach((item) => {
					if (item) {
						res.push(item);
					}
				});
				return res;
			},
		},
	};
</script>
<style lang="scss">
	.item-box {
		position: relative;
		display: block;
		margin-bottom: 10px;
		padding-bottom: 30px;
		border-bottom: 1px solid #eee;
		.news-title {
			display: block;
			font-size: 18px;
			color: #333;
			line-height: 24px;
			height: 48px;
			overflow: hidden;
			width: 100%;
			text-align: justify;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}
		.news-info {
			font-size: 13px;
			color: #999;
			line-height: 18px;
			height: 18px;
			width: 100%;
			white-space: nowrap;
			position: absolute;
			bottom: 5px;
			.time {
				margin-left: 10px;
			}
		}
		.img-area {
			display: flex;
			flex-wrap: nowrap;
			justify-content: space-between;
			.news-img {
				display: block;
				width: 30vw;
				height: 18.5vw;
				max-width: 192px;
				max-height: 118px;
			}
		}
		&.one-img {
			padding-bottom: 10px;
			.main-area {
				display: flex;
				flex-wrap: nowrap;
				justify-content: space-between;
				padding-bottom: 0;
				.text-area {
					width: 65vw;
				}
				.img-area {
					display: block;
					margin-left: 15px;
				}
				.news-info {
					bottom: 3px;
				}
			}
		}
		&.more-img {
			.img-area {
				margin: 6px 0;
			}
		}
	}
</style>